import type { OfferteStatus, StatusEntry } from "../../../../types";

export function getLatestStatus(statuses: StatusEntry[] | null | undefined): OfferteStatus | null {
  if (!Array.isArray(statuses) || statuses.length === 0) return null;
  return (statuses[statuses.length - 1]?.status as OfferteStatus) || null;
}

export function getStatusLabel(status: OfferteStatus | null): string {
  switch (status) {
    case "alles_geaccepteerd":
      return "Geaccepteerd";
    case "deels_geaccepteerd":
      return "Wacht op controle";
    case "foute_inzending":
      return "Foute inzending";
    case "afgewezen":
      return "Afgewezen";
    case "aangepast":
      return "Aangepast";
    case "verzonden":
      return "Te ondertekenen";
    case "bekeken":
      return "Bekeken";
    case "ingepland":
      return "Ingepland";
    case "ingetrokken":
      return "Ingetrokken";
    case "gefactureerd":
      return "Gefactureerd";
    default:
      return "Open";
  }
}

export function getStatusColor(status: OfferteStatus | null): string {
  switch (status) {
    case "alles_geaccepteerd":
      return "alles_geaccepteerd";
    case "deels_geaccepteerd":
      return "deels_geaccepteerd";
    case "foute_inzending":
      return "foute_inzending";
    case "afgewezen":
      return "afgewezen";
    case "aangepast":
      return "aangepast";
    case "verzonden":
      return "verzonden";
    case "bekeken":
      return "bekeken";
    case "ingepland":
      return "ingepland";
    case "ingetrokken":
      return "ingetrokken";
    case "gefactureerd":
      return "gefactureerd";
    default:
      return "nieuw";
  }
}
